<template>
	<div class="relative flex flex-col gap-2">
		<div class="flex items-end gap-3">
			<LabeledObject full :required="required">
				<template #label>{{ trans(label) }}</template>
				<input v-model="term" type="text" autocomplete="off" @keydown.enter.stop="search">
			</LabeledObject>
			<PrimaryButton :color="Color.Blue" @click.stop="search">
				<i class="fa-solid fa-search"/>
			</PrimaryButton>
		</div>
		<SearchResults v-if="results.length > 0 || isNotEmpty(morphResults)" :relative="relative">
			<List v-if="morph">
				<template v-for="(abstractItems, abstractTitle) in morphResults">
					<template v-if="abstractItems.length > 0">
						<ListItem v-for="item in abstractItems" :title="item[attribute]" :subtitle="trans(`${abstractPrefix}${abstractTitle}.title`)" @click.stop="select(item)"/>
					</template>
				</template>
			</List>
			<List v-else>
				<ListItem v-for="item in results" :title="item[attribute]" @click.stop="select(item)"/>
			</List>
		</SearchResults>
	</div>
</template>
<script setup lang="ts">
import _ from 'lodash'
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import List from '@/Components/UI/Lists/List.vue'
import ListItem from '@/Components/UI/Lists/ListItem.vue'
import {defineEmits, defineProps, Ref, ref} from 'vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import SearchResults from '@/Components/Search/SearchResults.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	label:string,
	morph?:boolean,
	attribute:string,
	relative?:boolean,
	required?:boolean,
	additionalData?:object,
	abstractPrefix?:string,
	searchType:'users'|'roles'|'majors'|'events'|'colleges'|'countries'|'locations'|'companies'|'activities',
}>()

const emit = defineEmits([
	'selected',
])

const term:Ref<string> = ref('')
const results:Ref<Array<object>> = ref([])
const morphResults:Ref<Array<Array<object>>> = ref([])
const label:Ref<string> = ref(props.label)
const morph:Ref<boolean> = ref(props.morph)
const searching:Ref<boolean> = ref(false)
const attribute:Ref<string> = ref(props.attribute)
const searchType:Ref<string> = ref(props.searchType)
const additionalData:Ref<object> = ref(props.additionalData ?? {})

function isNotEmpty(o:object):boolean{
	return !_.isEmpty(o)
}

function search(){
	if(!searching.value && term.value.length >= 3){
		searching.value = true
		showInfo(trans('general.searching'))
		axios.post(route('search.index', searchType.value), {
			term: term.value,
			...additionalData.value,
		}).then(({data}) => {
			showSuccess(trans('general.shown'))
			if(morph.value){
				morphResults.value = data.results
			} else {
				results.value = data.results
			}
		}).catch(showValidationErrors).finally(() => {
			searching.value = false
		})
	}
}

function select(item:any):void{
	if(morph.value){
		emit('selected', item.morpher, item)
	} else {
		emit('selected', item)
	}
	term.value = ''
	results.value = []
	morphResults.value = []
}
</script>